import {Card, CardActions, CardHeader, CardMedia, CardTitle, CardText} from 'material-ui/Card';
import moment from 'moment'
import FontIcon from 'material-ui/FontIcon';
import LinearProgress from 'material-ui/LinearProgress'

import { SearchConsoleStore } from 'stores'
import { SearchConsoleActions } from 'actions'
import { HelpEmail } from 'components'
import SearchConsoleCard from './SearchConsoleCard'
import SearchConsoleGraph from './SearchConsoleGraph'
import SearchConsolePlaceholder from './SearchConsolePlaceholder'

import SearchConsoleUtils from 'utils/SearchConsoleUtils'
import { SearchConsoleIntervals } from 'utils/Enum'

import AccessRevokedError from './partials/AccessRevokedError'
import SiteUnverifiedError from './partials/SiteUnverifiedError'
import GenericError from './partials/GenericError'
import './searchConsole.scss'

const DATE_FORMAT = "MMMM D"

export default class SearchConsole extends React.Component {
  static contextTypes = {
    currentUser: React.PropTypes.object.isRequired
  }

  static propTypes = {
    searchAnalyticsQuery: React.PropTypes.object,
    searchConsoleSite: React.PropTypes.any,
    searchAnalyticsQueryError: React.PropTypes.object,
    onRefresh: React.PropTypes.func.isRequired,
    fetchingSearchAnalyticsQuery: React.PropTypes.bool.isRequired,
    compact: React.PropTypes.bool
  }

  state = {
    metric: 'impressions',
    interval: 'week'
  }

  isData() {
    return this.props.searchAnalyticsQuery &&
      this.props.searchAnalyticsQuery.data &&
      this.props.searchAnalyticsQuery.data.rows
  }

  currentPeriod() {
    const { interval } = this.state

    return SearchConsoleUtils.getWholePeriod(this.props.searchAnalyticsQuery.data.rows, SearchConsoleIntervals[interval].count, interval)
  }

  periodAggregates(period) {
    return [
      {
        title: "Total Impressions",
        value: Math.round(SearchConsoleUtils.metricSumForPeriod(period, 'impressions')),
        key: 'impressions'
      },      
      {
        title: "Total Clicks",
        value: Math.round(SearchConsoleUtils.metricSumForPeriod(period, 'clicks')),
        key: 'clicks'
      },      
      {
        title: "Average CTR",
        value: Math.round(SearchConsoleUtils.metricAverageForPeriod(period, 'ctr', 'impressions') * 1000) / 10,
        key: 'ctr'
      },
      {
        title: "Average Position",
        value: Math.round(SearchConsoleUtils.metricAverageForPeriod(period, "position")),
        key: 'position'
      }
    ]
  }

  handleIntervalChange = interval => {
    this.setState({ interval });
  }

  renderCurrentPeriod() {
    return (
      <h4 className="medium-spacing--left small-spacing--top">
        Last {this.state.interval === 'week' ? '3 Months' : '30 Days'}
      </h4>
    )
  }

  renderSuccess() {
    const currentPeriodAggregates = this.periodAggregates(this.currentPeriod())

    return (
      <div>
        <div className="manageplus__panel manageplus__card">
          {!this.props.compact && <h2 className="manageplus__header">SEO Trends</h2>}
          {!this.props.compact && this.props.searchConsoleSite && <div className="medium-spacing--left body2">{this.props.searchConsoleSite}</div>}
          {!this.props.compact && this.renderCurrentPeriod() }
          <div className="search-console__card-container">
            {currentPeriodAggregates.map(aggrObj => (
              <SearchConsoleCard
                key={`metric-${aggrObj.key}`}
                title={aggrObj.title}
                onSelect={() => this.setState({ metric: aggrObj.key })}
                selected={this.state.metric === aggrObj.key}
                metricSuffix={aggrObj.key === 'ctr' ? '%' : ''}
                currentMetric={aggrObj.value}
                compact={this.props.compact}
                previousMetric={0} />
            ))}
          </div>
          <div className="medium-spacing--right medium-spacing--left medium-spacing--top large-spacing--bottom search-console__graph-container">
            <SearchConsoleGraph
              data={this.props.searchAnalyticsQuery.data.rows}
              metric={this.state.metric}
              interval={this.state.interval}
              onChangeInterval={this.handleIntervalChange}
              compact={this.props.compact}
            />
          </div>
        </div>
      </div>
    )
  }

  renderNoData() {
    const metrics = ['Total Impressions', 'Total Clicks', 'Average CTR', 'Average Position']

    if (this.props.compact) {
      return (
        <SearchConsolePlaceholder>
          <h3>Your Search Data is Being Imported by Google</h3>
          <p className="body1 medium-spacing--top">
            This can take up to 3 days to complete. Once your data has been<br/>imported you can view the search trends for your site.
          </p>
          <p className="body2 large-spacing--top">
            If you have any questions please email us at <HelpEmail />
          </p>
        </SearchConsolePlaceholder>
      )
    } else {
      return (
        <div className="manageplus__panel manageplus__card manageplus__card__no-data">
          <h2 className="manageplus__header">SEO Trends</h2>
          {this.props.searchConsoleSite && <div className="medium-spacing--left body2">{this.props.searchConsoleSite}</div>}
          <h4 className="medium-spacing--left small-spacing--top">Last 3 Months</h4>
          <div className="search-console__card-container">
            {metrics.map((metric, index) => (
              <SearchConsoleCard placeholder compact={this.props.compact} key={`empty-metric-${index}`} title={metric} />
            ))}
          </div>
          <div className="medium-spacing--right medium-spacing--left medium-spacing--top large-spacing--bottom search-console__graph-container">
            <SearchConsoleGraph placeholder compact={this.props.compact} />
            <div className="search-console__graph-container__overlay">
              <h3>Your Search Data is Being Imported by Google</h3>
              <p className="body1 medium-spacing--top">
                This can take up to 3 days to complete. Once your data has been<br/>imported you can view the search trends for your site.
              </p>
              <p className="body2 large-spacing--top">
                If you have any questions please email us at <HelpEmail />
              </p>
            </div>
          </div>
        </div>
      )
    }
  }

  renderErrorAccessRevoked() {
    if (this.props.compact) {
      return (
        <SearchConsolePlaceholder>
          <AccessRevokedError user={this.context.currentUser}/>
        </SearchConsolePlaceholder>
      )
    } else {
      return <AccessRevokedError user={this.context.currentUser}/>
    }
  }

  renderErrorGeneric() {
    if (this.props.compact) {
      return (
        <SearchConsolePlaceholder>
          <GenericError user={this.context.currentUser} onRefresh={::this.props.onRefresh} />
        </SearchConsolePlaceholder>
      )
    } else {
      return <GenericError user={this.context.currentUser} onRefresh={::this.props.onRefresh} />
    }
  }

  renderWarningSiteUnverified() {
    if (this.props.compact) {
      return (
        <SearchConsolePlaceholder>
          <SiteUnverifiedError user={this.context.currentUser} site={this.context.currentUser.searchConsoleSite} />
        </SearchConsolePlaceholder>
      )
    } else {
      return <SiteUnverifiedError user={this.context.currentUser} site={this.context.currentUser.searchConsoleSite} />
    }
  }

  renderError() {
    const error = this.props.searchAnalyticsQueryError.response.data.error
    if (!error) return this.renderErrorGeneric()

    if (/^user_does_not_have_sufficient_permission_for_site/.test(error.message)) {
      return this.renderWarningSiteUnverified()
    }

    switch(error.message) {
      case "invalid_grant":
      case "invalid_token":
      case "invalid_credentials":
        return this.renderErrorAccessRevoked()
      default:
        return this.renderErrorGeneric()
    }
  }

  maybeRenderNoData() {
    return !this.isData() && this.renderNoData()
  }

  maybeRenderSuccess() {
    return this.renderSuccess()
  }

  maybeRenderError() {
    return this.props.searchAnalyticsQueryError && this.renderError()
  }

  renderLoading() {
    if (this.props.compact) {
      return (
        <SearchConsolePlaceholder>
          <h4 className="medium-spacing2--bottom">Loading Search Data...</h4>
          <LinearProgress style={{maxWidth: 300}}mode="indeterminate" />
        </SearchConsolePlaceholder>
      );
    } else {
      return <div>Loading…</div>
    }
  }

  maybeRenderLoading() {
    return this.props.fetchingSearchAnalyticsQuery && this.renderLoading()
  }

  render() {
    return (
      <div>
        {this.maybeRenderLoading() || this.maybeRenderError() || this.maybeRenderNoData() || this.maybeRenderSuccess()}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/search_console/SearchConsole.js